//计划状态
const adsetStatus = [
  { value: 'AD_STATUS_DELIVERY_OK',  label: '投放中'},
  { value: 'AD_STATUS_DISABLE',  label: '计划暂停'},
  { value: 'AD_STATUS_AUDIT',  label: '新建审核中'},
  { value: 'AD_STATUS_REAUDIT',  label: '修改审核中'},
  { value: 'AD_STATUS_DONE',  label: '已完成'},
  { value: 'AD_STATUS_CREATE',  label: '计划新建'},
  { value: 'AD_STATUS_AUDIT_DENY',  label: '审核不通过'},
  { value: 'AD_STATUS_BALANCE_EXCEED',  label: '账户余额不足'},
  { value: 'AD_STATUS_BUDGET_EXCEED',  label: '超出预算'},
  { value: 'AD_STATUS_NOT_START',  label: '未到达投放时间'},
  { value: 'AD_STATUS_NO_SCHEDULE',  label: '不在投放时段'},
  { value: 'AD_STATUS_CAMPAIGN_DISABLE',  label: '已被广告组暂停'},
  { value: 'AD_STATUS_CAMPAIGN_EXCEED',  label: '广告组超出预算'},
  { value: 'AD_STATUS_DELETE',  label: '已删除'},
  { value: 'AD_STATUS_ADVERTISER_BUDGET_EXCEED',  label: '超出广告主日预算'},
]

export default {
  adsetStatus
}